import React from 'react';
import { Link } from 'react-router-dom';
import { formatEuro } from '../lib/api';
import './Shop.css';

const CartPage = ({
  cartItems,
  cartTotals,
  onUpdateQty,
  onRemoveItem,
  onClearCart,
  onCheckout,
  checkoutEnabled = true,
  legalAccepted,
  onLegalAcceptedChange,
  legalError,
  isCheckoutLoading,
  checkoutError
}) => {
  const isEmpty = cartItems.length === 0;
  const isCheckoutDisabled = !checkoutEnabled;

  return (
    <section className="cart-page">
      <h2 className="shop-title">Il tuo carrello</h2>

      {isEmpty && (
        <div className="cart-empty-state">
          <p>Il carrello e' vuoto.</p>
          <Link className="shop-back-link" to="/shop">
            Vai allo shop
          </Link>
        </div>
      )}

      {!isEmpty && (
        <>
          <div className="cart-list">
            {cartItems.map((item) => (
              <article key={item.id} className="cart-item">
                <div className="cart-item-main">
                  <h3>
                    <Link className="cart-item-link" to={`/shop/${item.slug}`}>
                      {item.name}
                    </Link>
                  </h3>
                  <p className="cart-item-meta">{formatEuro(item.price_cents)} x {item.qty}</p>
                </div>

                <div className="cart-item-actions">
                  <label htmlFor={`qty-${item.id}`}>Qta</label>
                  <input
                    id={`qty-${item.id}`}
                    className="cart-qty-input"
                    type="number"
                    min="1"
                    max="99"
                    value={item.qty}
                    onChange={(event) => onUpdateQty(item.id, Number(event.target.value))}
                  />
                  <button className="cart-remove-button" onClick={() => onRemoveItem(item.id)}>
                    Rimuovi
                  </button>
                </div>
              </article>
            ))}
          </div>

          <section className="cart-summary">
            <p>
              <strong>Totale prodotti:</strong> {formatEuro(cartTotals.subtotalCents)}
            </p>
            <p>
              <strong>Peso totale:</strong> {cartTotals.totalWeightGrams} g
            </p>
            {isCheckoutDisabled ? (
              <p className="cart-summary-note">
                Checkout temporaneamente non disponibile. Puoi continuare a comporre il carrello.
              </p>
            ) : (
              <>
                <p className="cart-summary-note">Spedizione calcolata al checkout Stripe.</p>
                <section className="checkout-legal-block">
                  <h3>Conferma pre-ordine</h3>
                  <p>
                    Prima di andare al pagamento, leggi e accetta i testi legali:{' '}
                    <Link to="/termini-vendita">Termini di vendita</Link>, <Link to="/privacy">Privacy policy</Link>{' '}
                    e <Link to="/spedizioni-resi">Spedizioni e resi</Link>.
                  </p>
                  <label className="checkout-legal-consent">
                    <input
                      type="checkbox"
                      checked={Boolean(legalAccepted)}
                      onChange={(event) => onLegalAcceptedChange?.(event.target.checked)}
                    />{' '}
                    Dichiaro di aver letto e accettato i termini sopra indicati.
                  </label>
                  {legalError && <p className="shop-state shop-error">{legalError}</p>}
                </section>
              </>
            )}
            <div className="cart-summary-actions">
              <Link className="shop-back-link" to="/shop">
                Continua acquisti
              </Link>
              <button
                className="cart-checkout-button"
                onClick={onCheckout}
                disabled={isCheckoutDisabled || isCheckoutLoading || !legalAccepted}
              >
                {isCheckoutDisabled
                  ? 'Checkout non disponibile'
                  : isCheckoutLoading
                    ? 'Reindirizzamento...'
                    : 'Procedi al pagamento'}
              </button>
              <button className="cart-clear-button" onClick={onClearCart}>
                Svuota carrello
              </button>
            </div>
            {checkoutError && <p className="shop-state shop-error">{checkoutError}</p>}
          </section>
        </>
      )}
    </section>
  );
};

export default CartPage;
